import { render } from "./Slide.vue?vue&type=template&id=4b8af5f5&scoped=true"
import script from "./Slide.vue?vue&type=script&lang=ts"
export * from "./Slide.vue?vue&type=script&lang=ts"

import "./Slide.vue?vue&type=style&index=0&id=4b8af5f5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4b8af5f5"

export default script